import React, { useState, useEffect, useRef } from 'react';
import { Container, Thead, Table, Th, Td, Modal_header, Pagination, Title_modal, Selecte, Tr, Div_add, Btn_add, Input, LabelField, H2, Span, DeletedButton } from './Vacation.style';
import { useTable, usePagination } from "react-table";
import useColumns from "../hooks/useColumns";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import { BiFirstPage, BiLastPage } from "react-icons/bi";
import { MdKeyboardArrowRight, MdKeyboardArrowLeft, MdAddToPhotos } from "react-icons/md";
import apis from '../../api';
import { BsTrash, BsPencil } from "react-icons/bs";
import ConfBar from '../ConfBar/ConfBar';
import Select from 'react-select';
import { DateInput } from '@opuscapita/react-dates';
import dateFormat from '../../services/DateFormat.service';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import '../../DataTableDemo.css';
import useParamsVacation from '../../helpers/useParamsVacation'
import { set } from 'lodash';
import { InputNumber } from 'primereact/inputnumber';
import Video from '../Video/Video';
import InfoIcon from '../InfoIcon/InfoIcon';
import useInfo from '../hooks/useInfo';
import "../../utils/tooltip.css"
import { Tooltip } from 'primereact/tooltip';
import { tableDate, timeToDate } from '../../services/tableDate.service';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { excelReport } from '../../services/excelReport.service';
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Appointment
Description : Pagina de Appointment para el CRUD de los cargos del aplicativo remunerlite.
Date Autor Modification
================================================================================
13/10/2021 Cristian Andres Pizo Mina - Pagina de Cargo
================================================================================ */
// let columns = [];
export default function Vacation() {
  const toast = useRef(null);
  const options_edit = []
  const setOptions_edit = []
  const setOptions_edit2 = []
  const [options, setOptions] = useState("");
  const [number_id, setNumber_id] = useState("");
  const [date_ini, setDate_ini] = useState("");
  const [date_end, setDate_end] = useState("");
  const [day_time, setDay_time] = useState("");
  const [day_money, setDay_money] = useState("");
  const [calendario, setCalendario] = useState([]);
  const [updateCodEmpleado, setUpdateCodEmpleado] = useState("");
  const [updateCalendario, setUpdateCalendario] = useState("");
  const [updateId, setUpdateId] = useState("");
  const [updateNumber_id, setUpdateNumber_id] = useState("");
  const [updateDate_ini, setUpdateDate_ini] = useState("");
  const [updateDate_end, setUpdateDate_end] = useState("");
  const [updateDay_time, setUpdateDay_time] = useState("");
  const [updateDay_money, setUpdateDay_money] = useState("");
  const [listaCalendario, setListaCalendario] = useState([]);
  const [deleteId, setDeleteId] = useState("");
  const [codEmpleado, setCodEmpleado] = useState("");
  const [rowId, setRowId] = useState(0);
  const [listaCodEmpleado, setListaCodEmpleado] = useState([]);
  const [smShow, setSmShow] = useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const [idVacation, setIdVacation] = useState([]);
  const [listasCargadas, setListasCargadas] = useState(false)

  const [smShow_, setSmShow_] = useState(false);
  const [isOpen_, setIsOpen_] = React.useState(false);

  const [smShowEliminar, setSmShowEliminar] = useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);

  const [params] = useParamsVacation();
  const [rowData, setRowData] = useState([""]);
  const data = rowData;
  const columns = useColumns();
  const headers = {
    authorization: localStorage.getItem('token')
  }
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(5);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const elementWidth = { width: "20rem" }
  const [isOpenH, setIsOpenH] = React.useState(false);
  const [historico, setHistorico] = useState([])
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingReport, setLoadingReport] = useState(false);
  const [loadPage, setLoadPage] = useState(false)

  /*Mensajes informativos*/
  const { info } = useInfo("NoveltiesVacation");

  useEffect(() => {
    setTabla();
  }, [rowId]);

  useEffect(() => {
    const historicTemplate = async () => {
      /*Se inicializan las propiedades del componente para la generación de reportes*/
      let plantilla = []
      params.forEach((p, index) => {
        if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
          plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
        else {
          plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
      })
      console.log(plantilla)
      setHistorico(plantilla)
    }
    historicTemplate()
  }, [params]);


  const table = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: 5,
        pageIndex: 0
      }
    },
    usePagination
  );

  const {
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize }
  } = table;

  const GetCalendar = async (contract = "") => {
    await apis.getNoveltiesCalendar(contract, headers).then(res => {
      let lista = res.data["CALENDAR"]
      let contenidoCalendario = []
      lista.forEach(element => {
        contenidoCalendario.push({ "value": '' + element.ID_CALENDAR + '', "label": '' + element.DETAIL + '' })
      })
      setListaCalendario(contenidoCalendario)
    }).catch(err => {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })
  }

  async function setListas() {
    GetCalendar()
    await apis.getVacationLists(localStorage.getItem("entity"), localStorage.getItem("client"), headers).then(res => {
      let codsEmpleados = res.data["CONTRACTS"]
      let contenidoCodEmpleado = []
      codsEmpleados.forEach(element => {
        contenidoCodEmpleado.push({ "value": '' + element.CODE + '', "label": '' + element.NAME + '' });
      })
      setListaCodEmpleado(contenidoCodEmpleado);
      setListasCargadas(true)
    }).catch(err => {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })
  }

  const showModal = () => {
    if (!listasCargadas) {
      setListas()
    }
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
    limpiar();
  };

  const showModal_ = () => {
    setIsOpen_(true);
  };

  const hideModal_ = () => {
    setIsOpen_(false);
    limpiar()
  };

  const showModalEliminar = (VACATION_ID) => {
    setDeleteId(VACATION_ID)
    setIsOpenEliminar(true);
  };

  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };

  const showModalH = () => {
    setIsOpenH(true);
  };

  const hideModalH = () => {
    setIsOpenH(false);
  };

  function inizilaizarData(rowData) {

    setOptions_edit.push({ "value": '' + rowData.ID_CALENDAR + '', "label": '' + rowData.CALENDAR + '' });
    setOptions_edit2.push({ "value": '' + rowData.CONTRACT_ID + '', "label": '' + rowData.CONTRACT_ID + '' });
    setUpdateCalendario(setOptions_edit);
    setUpdateCodEmpleado(setOptions_edit2);
    setUpdateDay_time(rowData.DAYS_TIE);
    setUpdateDay_money(rowData.DAYS_DIN);
    let fechaInicio = timeToDate(rowData.START_DATE)
    let fechaFin = timeToDate(rowData.END_DATE)
    setUpdateDate_ini(invDateFormat(fechaInicio))
    setUpdateDate_end(invDateFormat(fechaFin))
    setIdVacation(rowData.VACATION_ID);
    showModal_();
  }


  async function completarRegistro() {

    if (validar(date_ini)) {
      setLoadingCreate(true)
      const _cliente = localStorage.getItem('client')
      const _entity = localStorage.getItem('entity')
      const _contract_id = codEmpleado;
      const _date_ini = dateFormat(date_ini);
      const _date_end = dateFormat(date_end);
      const _day_time = day_time;
      const _day_money = day_money;
      const _calendario = calendario.value;

      const vacation = {
        CLIENT: _cliente,
        ENTITY: _entity,
        ID_CALENDAR: _calendario,
        START_DATE: _date_ini,
        END_DATE: _date_end,
        DAYS_TIE: _day_time,
        DAYS_DIN: _day_money,
        CONTRACT_ID: _contract_id
      }

      if (date_ini) {
        await apis.getValidDateIni(_entity, _cliente, _date_ini, _contract_id, headers).then(res => {
          setLoadingCreate(false)
          apis.postVacation(vacation, headers).then(res => {
            setLoadingCreate(false)
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Vacación agregadas exitosamente', life: 4000 });
            hideModal();
            setTabla();
            limpiar();
          }).catch(err => {
            setLoadingCreate(false)
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
          })
        }).catch(err => {
          setLoadingCreate(false)
          toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
          setDate_ini(null)
          setDate_end(null)
        })
      } else {
        apis.postVacation(vacation, headers).then(res => {
          setLoadingCreate(false)
          toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Vacación agregadas exitosamente', life: 4000 });
          hideModal();
          setTabla();
          limpiar();
        }).catch(err => {
          setLoadingCreate(false)
          toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
        })
      }


    }
  }

  async function limpiar() {
    setCodEmpleado("");
    setCalendario("");
    setDay_time("");
    setDay_money("");
    setDate_ini(null);
    setDate_end(null)
  }

  async function setTabla() {
    await apis.getVacation(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
      if (res.data["VACATIONS"].length > 0) {
        let data = res.data["VACATIONS"]
        let contenidoTabla = []
        data.forEach(element => {
          let calendar = element["ID_CALENDAR"].split("|")
          let datos = element["NAME"].split("|")
          let fechaInicio = tableDate(element.START_DATE)
          let fechaFin = tableDate(element.END_DATE)
          contenidoTabla.push({
            VACATION_ID: element.VACATION_ID, CONTRACT_ID: element.CONTRACT_ID, ID_CALENDAR: calendar[0], CALENDAR: calendar[1],
            DAYS_DIN: element.DAYS_DIN, DAYS_TIE: element.DAYS_TIE, NUMBER_ID: datos[0], NAME: datos[1], END_DATE: fechaFin,
            START_DATE: fechaInicio
          })
        })
        setRowData(contenidoTabla)
        setLoadPage(true)
      } else {
        setRowData([])
        setLoadPage(true)
      }
    }).catch(err => {
      setLoadPage(true)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })
  }

  async function actualizar() {

    setLoadingUpdate(true)

    const _client = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity');
    const _id_calendar = updateCalendario[0].value;
    const _contract_id = updateCodEmpleado[0].value;
    const _date_ini = dateFormat(updateDate_ini);
    const _date_end = dateFormat(updateDate_end);
    const _day_time = updateDay_time;
    const _day_din = updateDay_money;
    const _vacation_id = idVacation;
    const vacation = {
      CLIENT: _client,
      ENTITY: _entity,
      ID_CALENDAR: _id_calendar,
      START_DATE: _date_ini,
      END_DATE: _date_end,
      DAYS_TIE: _day_time,
      DAYS_DIN: _day_din,
      CONTRACT_ID: _contract_id,
      VACATION_ID: _vacation_id,
    }
    if (updateDate_ini) {
      await apis.getValidDateIni(_entity, _client, _date_ini, _contract_id, headers).then(res => {
        apis.putVacation(vacation, headers).then(res => {
          setLoadingUpdate(false)
          toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Registro actualizado exitosamente', life: 4000 });
          setIsOpen_(false);
          setTabla();
        }).catch(err => {
          setLoadingUpdate(false)
          toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
        })

      }).catch(err => {
        setLoadingUpdate(false)
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
        setUpdateDate_ini(null)
        setUpdateDate_end(null)
      })

    } else {
      apis.putVacation(vacation, headers).then(res => {
        setLoadingUpdate(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Registro actualizado exitosamente', life: 4000 });
        setIsOpen_(false);
        setTabla();
      }).catch(err => {
        setLoadingUpdate(false)
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    }
  }

  async function eliminar() {

    setLoadingDelete(true)

    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity');
    const _idVacation = deleteId;
    await apis.deleteVacation(_entity, _cliente, _idVacation, headers).then(res => {
      setLoadingDelete(false)
      setIsOpenEliminar(false)
      toast.current.show({ severity: 'info', summary: 'Éxito', detail: 'Vacación eliminada', life: 4000 });
    }).catch(err => {
      setLoadingDelete(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })

    setTabla();
  }

  function validar(existeFechaIni) {
    if (calendario) {
      if (codEmpleado) {
        if (day_time || day_money) {
          if (day_time && day_money) {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Solo agrega dias en tiempo o dinero', life: 4000 });
            setDay_time("")
            setDay_money("")
            return false;
          } if (day_time) {
            if (existeFechaIni) {
              return true;
            } else {
              toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'agregue fecha inicio', life: 4000 });
            }
          } else {
            setDate_ini(null)
            setDate_end(null)
            return true;
          }
        } else {
          toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregue los dias en tiempo o dinero', life: 4000 });
          return false;
        }
      } else {
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Seleccione un empleado', life: 4000 });
        return false;
      }
    } else {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Seleccione un calendario', life: 4000 });
      return false;
    }

  }

  const handleChange = async (event) => {

    if (validar(event)) {

      const _cliente = localStorage.getItem('client')
      const _entity = localStorage.getItem('entity')
      const _contract_id = codEmpleado;
      const _date_ini = dateFormat(event.value);
      const _day_time = day_time;
      setDate_ini(event.value);

      if (_day_time == "" || _day_time == null || _day_time == undefined) {
        await apis.getEnd_DateVacation(_entity, _cliente, _date_ini, 1, _contract_id, headers).then(res => {
          setDate_end(invDateFormat(res.data.END_DATE))
        }).catch(err => {
          toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
        })
      } else {
        await apis.getEnd_DateVacation(_entity, _cliente, _date_ini, _day_time, _contract_id, headers).then(res => {
          setDate_end(invDateFormat(res.data.END_DATE))
        }).catch(err => {
          toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
        })
      }
    }


  }



  const handleChangeUpdate = async (event) => {

    setUpdateDate_ini(event.value);
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _contract_id = updateCodEmpleado[0].value;
    const _date_ini = dateFormat(event.value);
    const _day_time = updateDay_time;

    await apis.getEnd_DateVacation(_entity, _cliente, _date_ini, _day_time, _contract_id, headers).then(res => {
      setUpdateDate_end(invDateFormat(res.data.END_DATE))
    }).catch(err => {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })


  }

  const handleChangeDiasFecha = async (date) => {
    setDate_ini(date)
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _contract_id = codEmpleado;
    const _date_ini = dateFormat(date);
    const _day_time = day_time;
    if (_date_ini) {
      apis.getEnd_DateVacation(_entity, _cliente, _date_ini, _day_time, _contract_id, headers).then(res => {
        setDate_end(invDateFormat(res.data.END_DATE))
      }).catch(err => {
        setDate_ini("")
        setDate_end("")
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    }
    else {
      setDate_ini("")
      setDate_end("")
    }
  }

  const handleUpdateChangeDiasFecha = async (date) => {

    setUpdateDate_ini(date)
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _contract_id = updateCodEmpleado[0].value;
    const _day_time = updateDay_time;
    const _date_ini = dateFormat(date);

    if (_date_ini) {
      apis.getEnd_DateVacation(_entity, _cliente, _date_ini, _day_time, _contract_id, headers).then(res => {
        setUpdateDate_end(invDateFormat(res.data.END_DATE))
      }).catch(err => {
        setUpdateDate_ini("")
        setUpdateDate_end("")
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    } else {
      setUpdateDate_ini("")
      setUpdateDate_end("")
    }
  }

  const handleChangeDiasTiempo = async (days) => {
    setDay_time(days)
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _contract_id = codEmpleado;
    const _date_ini = dateFormat(date_ini);
    const _day_time = days;
    if (_date_ini && _day_time !== "" && _day_time > 0) {
      apis.getEnd_DateVacation(_entity, _cliente, _date_ini, _day_time, _contract_id, headers).then(res => {
        setDate_end(invDateFormat(res.data.END_DATE))
      }).catch(err => {
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    }
    else {
      setDate_end("")
    }
  }

  const handleUpdateChangeDiasTiempo = async (days) => {

    setUpdateDay_time(days)
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _contract_id = updateCodEmpleado[0].value;
    // const _date_ini = dateFormat(new Date());
    const _day_time = days;
    const _date_ini = dateFormat(updateDate_ini);

    if (_date_ini && _day_time !== "" && _day_time > 0) {
      apis.getEnd_DateVacation(_entity, _cliente, _date_ini, _day_time, _contract_id, headers).then(res => {
        setUpdateDate_end(invDateFormat(res.data.END_DATE))
      }).catch(err => {
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    }
  }
  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Claro'
  });



  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  //Boton Agregar Persona izquierda de la tabla
  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={showModal} />
        <Button label="Reporte histórico" icon="pi pi-file-excel" className="p-button-sucess mr-2 p-button-sm" onClick={() => showModalH()} />
      </React.Fragment>
    )
  }

  //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex">
        <Button icon="pi pi-pencil" className="p-button-warning  p-button-sm text-xs mr-2" onClick={() => { inizilaizarData(rowData) }} />
        <Button icon="pi pi-trash" className="p-button-danger  p-button-sm text-xs" onClick={() => { showModalEliminar(rowData.VACATION_ID) }} />
      </div>
    )
  }

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
        </IconField>
      </div>
    )
  }

  async function postVacationHistoryReport() {

    setLoadingReport(true)

    /*Función encargada de cargar la informacion para generar el reporte de histótico de ausentismos*/
    let finalReport = []
    const client = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const option = "1"
    let report = {
      CLIENT: client,
      ENTITY: _entity,
      OPTION: option,
      REPORTS: []
    }
    let max = 0
    historico.forEach(h => {
      let size = h.SHEET.length
      if (size > max) {
        max = size
      }
    })
    for (let i = 0; i < max; i++) {
      report.REPORTS.push({ PARAMETERS: [] })
    }

    historico.forEach(h => {
      h.SHEET.forEach(e => {
        report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
      })
    })
    try {
      console.log(report)
      await apis.postReportVacationHistory(report, headers).then(res => {
        setLoadingReport(false)
        finalReport = res.data
        excelReport(finalReport, "reporteHistoricoVacaciones")
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte histórico de vacaciones generado existosamente" });
        hideModalH();
      })
    }
    catch (err) {
      setLoadingReport(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'LOV_REASON': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  //Nombre de las opciciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];



  const addFooter = (
    <div>
      <Button onClick={hideModal}>Cancelar</Button>
      <Button onClick={completarRegistro} loading={loadingCreate} label='Guardar'></Button>
    </div>
  );

  const addHeader = (
    <div>
      <h3>Agregar Vacación</h3>
    </div>
  );

  const updateFooter = (
    <div>
      <Button onClick={hideModal_}>Cancelar</Button>
      <Button onClick={actualizar} loading={loadingUpdate} label='Guardar'></Button>
    </div>
  );

  const updateHeader = (
    <div>
      <h3>Actualizar Vacación</h3>
    </div>
  );

  const deleteFooter = (
    <div>
      <Button onClick={hideModalEliminar}>Cancelar</Button>
      <Button onClick={eliminar} loading={loadingDelete} label='Si'></Button>
    </div>
  );

  const deleteHeader = (
    <div>
      <h3>¿Desea eliminar la Vacación?</h3>
    </div>
  );

  const footerHS = (
    <div>
      <Button onClick={() => postVacationHistoryReport()} loading={loadingReport} label='Generar'></Button>
    </div>
  );

  const headerHS = (
    <div>
      <h3>Parámetros reporte histórico de vacaciones</h3>
    </div>
  )

  /*Funciones que manejan el cambio en los campos de entrada del modal de gneración del reporte*/
  function handleChangeH(e, d, index) {
    setHistorico(h => {
      let newHistorico = [...h]
      newHistorico[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHistorico
    })

  }

  async function handleChangeDateH(e, d, index) {
    let date = dateFormat(e.value)
    setHistorico(h => {
      let newHistorico = [...h]
      newHistorico[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHistorico
    })
  }

  async function handleChangeTextH(e, d, index) {
    setHistorico(h => {
      let newHistorico = [...h]
      newHistorico[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHistorico
    })
  }

  const iniDateTemplate = (rowData) => {
    const date = timeToDate(rowData.START_DATE);
    return date
  }

  const endDateTemplate = (rowData) => {
    const date = timeToDate(rowData.END_DATE);
    return date
  }

  return (

    <div>
      <div className="surface-100	 px-4 py-2 md:px-6 lg:px-8">
        <Toast ref={toast} />
        <Tooltip target=".info" className='indigo-tooltip ml-1' />
        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-4">
          <span className="text-900">Vacaciones</span>
          <Video header="Instructivo proceso novedades" url={localStorage.getItem('NOVELTIESVACATION_VIDEO')} />
        </div>

        <Dialog header={addHeader} footer={addFooter} visible={isOpen} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
          <Tooltip target=".info" className='indigo-tooltip ml-1' />
          <LabelField htmlFor="label">Código empleado</LabelField>
          <InfoIcon msg={info[1]}
            element={
              <Dropdown filter showClear filterBy="label" style={elementWidth} value={codEmpleado} options={listaCodEmpleado} placeholder={"Seleccione un Empleado"}
                onChange={(e) => { setCodEmpleado(e.value); GetCalendar(e.value) }} />
            }
          />
          <LabelField htmlFor="label">Calendario</LabelField>
          <InfoIcon msg={info[0]}
            element={
              <Dropdown style={elementWidth} value={calendario.value} disabled={!codEmpleado}
                options={listaCalendario} placeholder={"Seleccione un calendario"} onChange={setCalendario}
                filter showClear filterBy="label" />
            }
          />
          <LabelField htmlFor="label">Dias tiempo</LabelField>
          <InfoIcon msg={info[2]}
            element={
              <InputNumber min={0} value={day_time} onChange={(e) => handleChangeDiasTiempo(e.value)} placeholder="Dias tiempo" disabled={!codEmpleado} />
            }
          />
          <LabelField htmlFor="label">Dias Dinero</LabelField>
          <InfoIcon msg={info[3]}
            element={
              <InputNumber min={0} value={day_money} onChange={(e) => setDay_money(e.value)} placeholder="Dias Dinero" disabled={!codEmpleado} />
            }
          />
          <LabelField htmlFor="label">Fecha inicio</LabelField>
          <InfoIcon msg={info[4]}
            element={
              <Calendar style={elementWidth} id="navigators" value={date_ini} onChange={(e) => handleChangeDiasFecha(e.value)} locale="es"
                dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon disabled={!codEmpleado}
              />
            }
          />
          <LabelField htmlFor="label">Fecha fin</LabelField>
          <InfoIcon msg={info[5]}
            element={
              <Calendar style={elementWidth} id="navigators" value={date_end} onChange={(e) => { setDate_end(e.value) }} locale="es"
                dateFormat="dd-mm-yy" yearRange="2010:2030" disabled={true} showIcon />
            }
          />
        </Dialog>

        <Dialog header={updateHeader} footer={updateFooter} visible={isOpen_} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal_}>
          <LabelField htmlFor="label">Dias tiempo</LabelField>
          <InputNumber min={0} value={updateDay_time} onChange={(e) => handleUpdateChangeDiasTiempo(e.value)} placeholder="Dias tiempo" />
          <LabelField htmlFor="label">Dias Dinero</LabelField>
          <InputNumber min={0} value={updateDay_money} onChange={(e) => setUpdateDay_money(e.value)} placeholder="Dias Dinero" />
          <LabelField htmlFor="label">Fecha inicio</LabelField>
          <Calendar style={elementWidth} id="navigators" value={updateDate_ini} onChange={(e) => handleUpdateChangeDiasFecha(e.value)} locale="es" dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon />
          <LabelField htmlFor="label">Fecha fin</LabelField>
          <Calendar style={elementWidth} id="navigators" value={updateDate_end} onChange={setUpdateDate_end} locale="es" dateFormat="dd-mm-yy" yearRange="2010:2030" disabled={true} showIcon />
        </Dialog>

        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>

        <Dialog header={headerHS} footer={footerHS} visible={isOpenH} bo
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalH}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
          {params.map((d, index) => {
            /*Generación dinámica de los parámetros para la generación del reporte histórico de ausentismos*/
            if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && historico.length > 0 && typeof historico[index] !== "undefined") {
              let label = d.LABEL;
              if (d.REQUIRED === "1") {
                label = label + "*"
              }
              switch (d.TYPE) {
                case "LIST":
                  let options = []
                  if (d.REQUIRED === "1") {
                    options = [...d.OPTIONS]
                  }
                  else {
                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                  }
                  return (<>
                    <LabelField htmlFor="label">{label}</LabelField>
                    <Dropdown
                      key={index}
                      style={elementWidth}
                      value={historico[index]["NAME"]}
                      options={options}
                      filter showClear filterBy="NAME"
                      optionLabel="NAME"
                      //optionTemplate={optionTemplate}
                      placeholder={historico[index]["NAME"] ? historico[index]["NAME"] : "Seleccione"}
                      onChange={(e) => handleChangeH(e, d, index)}
                    />
                  </>
                  );
                case "DATE":
                  return (<>
                    <LabelField htmlFor="label">{label}</LabelField>
                    <Calendar key={d} style={elementWidth} id="navigators" value={historico[index].CODE}
                      onChange={(e) => handleChangeDateH(e, d, index)}
                      locale="es" dateFormat="dd-mm-yy" showIcon placeholder={historico[index].CODE}
                      yearRange="2010:2030" /></>
                  );
                default:
                  return (<>
                    <LabelField htmlFor="label">{label}</LabelField>
                    <InputText
                      key={d}
                      style={elementWidth}
                      id="label2"
                      type="text"
                      value={historico[index]}
                      onChange={(e) => handleChangeTextH(e, d, index)}
                    /></>
                  )
              }
            }
          })}
        </Dialog>

        <ConfBar />

        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar className="mb-4" start={leftToolbarTemplate} ></Toolbar>
            <DataTable className="text-xs" value={rowData} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              scrollHeight="flex" dataKey="STATIC_ID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['CONTRACT_ID', 'NUMBER_ID', 'NAME', 'START_DATE', 'DAYS_TIE', 'END_DATE', 'DAYS_DIN', 'CALENDAR']}
              header={header1} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
              <Column field="NUMBER_ID" header="Identificación" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
              <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
              <Column field="START_DATE" body={iniDateTemplate} header="Fecha inicio" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha inicio" sortable></Column>
              <Column field="END_DATE" body={endDateTemplate} header="Fecha fin" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha fin" sortable></Column>
              <Column field="DAYS_TIE" header="Dias Tiempo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Dias Tiempo" sortable></Column>
              <Column field="DAYS_DIN" header="Dias Dinero" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Dias Dinero" sortable></Column>
              <Column field="CALENDAR" header="Calendario" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Calendario" sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '50px', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>
      </div>
    </div>
  );
}